import { createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { getDateTime } from '@sda/utils/date';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Document } from '@sda/interfaces/show/document';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const documentAdapter = createEntityAdapter<Document & FetchDataType>({
  sortComparer: (a, b) => getDateTime(b.startDate).toMillis() - getDateTime(a.startDate).toMillis(),
});

const documentsSlice = createSlice({
  initialState: documentAdapter.getInitialState(),
  name: Reducers.DOCUMENTS,
  reducers: {
    ...extractSharedActions(documentAdapter),
  },
});

export default documentsSlice.reducer;
